import { Card } from "@fpsoftware/mvp";
import { useProfile } from "@/auth/useProfile";
import { Container } from "@/components/grid/Container";
import { AppPage } from "@/layout/AppLayout";
import { PageSubmit } from "@/submit/PageSubmit";

export const PageMortgageExtract = () => {
  const { profile } = useProfile();

  return (
    <AppPage title="RFQ from statement">
      <Container>
        <Card>
          <PageSubmit pov="broker" token={profile.companyToken} />
        </Card>
      </Container>
    </AppPage>
  );
};
